module.exports = __webpack_public_path__ + "static/img/smartIntera.8ed9bc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smartIntera.png
// module id = Qert
// module chunks = 1